let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kjW7M"), load("7HLIY"), load("as7Oi"), load("9T4db"), load("5AfWB")]).then(() => parcelRequire('jubPE'));